require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = function _default() {
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, _react["default"].createElement("path", {
    d: "M11.688 15a16.793 16.793 0 0 1 6.75-5.316c-.875 1.484-1.602 3.289-2.165 5.316h3.512c1.317-4.098 3.328-6.668 5.215-6.668s3.898 2.57 5.215 6.668h3.512c-.563-2.027-1.29-3.832-2.164-5.316A16.74 16.74 0 0 1 38.313 15h3.984C38.828 9.031 32.383 5 25 5 17.617 5 11.172 9.031 7.707 15zm26.624 20a16.755 16.755 0 0 1-6.746 5.316c.872-1.484 1.598-3.289 2.16-5.316h-3.511c-1.317 4.098-3.328 6.668-5.215 6.668-1.883 0-3.895-2.57-5.21-6.668h-3.517c.563 2.027 1.29 3.832 2.165 5.316A16.767 16.767 0 0 1 11.688 35H7.707c3.465 5.969 9.91 10 17.293 10 7.383 0 13.828-4.031 17.293-10zm0 0M8.652 30H6.254L3.64 20h2.64l1.332 6.633h.125L9.34 20h2.035l1.656 6.633h.125L14.465 20h2.62l-2.612 10H12.09l-1.668-6.125h-.125zm14.637 0h-2.398l-2.614-10h2.641l1.328 6.633h.125L23.977 20h2.035l1.656 6.633h.125L29.102 20h2.62L29.11 30h-2.382l-1.668-6.125h-.125zm14.637 0h-2.399l-2.613-10h2.64l1.329 6.633h.125L38.609 20h2.04l1.656 6.633h.125L43.738 20h2.621l-2.613 10h-2.383l-1.672-6.125h-.125zm0 0"
  }));
};

exports["default"] = _default;